const folders = {
  folders: "Folders",
  createFolder: "Create Folder",
  folderName: "Folder Name",
  folderIcon: "Icon",
  gridSize: "Grid Size",
  columns: "Columns",
  rows: "Rows",
  items: "items",
  pin: "Pin Open",
  unpin: "Unpin",
  addWidget: "Add Widget",
  addShortcut: "Add Shortcut",
  addAction: "Add Action",
  widgetsTab: "Widgets",
  actionsTab: "Actions",
  noItems: "Folder is empty",
  editFolder: "Edit Folder",
  deleteFolder: "Delete Folder",
  bookmarksTab: "Bookmarks",
  addBookmark: "Add",
  bookmarkName: "Bookmark name",
  bookmarkUrl: "URL or /dashboard/...",
  bookmarkIcon: "Icon",
  addCurrentPage: "Current Page",
} as const;
export default folders;
